import React, { useEffect, useRef, useState } from 'react'
import { Box, Button, Card, CardHeader, Container, Dialog, DialogContent, DialogTitle, Divider, Grid, IconButton, MenuItem, Switch, TextField, Tooltip, Typography, styled } from '@mui/material'
import { Formik } from 'formik'
import * as Yup from "yup";
import CloseIcon from '@mui/icons-material/Close';
import CancelIcon from '@mui/icons-material/Cancel';
import axios from 'axios';
import { toast } from 'react-toastify';

export default function CategoryDialog({ dialogOpen, setDialogOpen, updateID, setUpdateID }) {
    const [categoryData, setcategoryData] = useState({
        categoryName: "",
        isActive: true
    })
    const [categoryID, setCategoryID] = useState(0);
    const [isUpdate, setIsUpdate] = useState(false);

    useEffect(() => {
        if (!updateID) {
            GetCategoryID();
        }
    }, [])

    useEffect(() => {
        GetcategoryDetailsByCategoryID();
    }, [updateID])

    function handleClose() {
        setDialogOpen(false);
        ClearData();
        setIsUpdate(false);
    }

    function handleChange(e) {
        const target = e.target;
        const value = target.value;
        setcategoryData({
            ...categoryData,
            [e.target.name]: value
        })
    }

    function handleStatusChange() {
        setcategoryData({
            ...categoryData,
            isActive: !categoryData.isActive
        })
    }

    function ClearData() {
        setcategoryData({
            ...categoryData,
            categoryName: "",
            isActive: true
        })
        GetCategoryID();
    }

    function UploadCategory() {
        if (isUpdate) {
            const UpdateModel = {
                categoryID: categoryID,
                categoryName: categoryData.categoryName.trim(),
                isActive: categoryData.isActive ? 1 : 0
            }

            axios.put('https://serveremilia.mylksystems.com/Category/updateCategory', UpdateModel).then((res) => {
                if (res.data.changedRows > 0) {
                    handleClose();
                    setCategoryID();
                    toast.success("Category Updated successfully!")
                }
            })
        } else {
            const SaveModel = {
                categoryID: categoryID,
                categoryName: categoryData.categoryName.trim(),
                isActive: categoryData.isActive ? 1 : 0
            };

            axios.post('https://serveremilia.mylksystems.com/Category/createCategory', SaveModel)
                .then((res) => {
                    if (res.data > 0) {
                        handleClose();
                        GetCategoryID();
                        toast.success("Category Added successfully!")
                    } else {
                        toast.error("Category Adding unsuccessfully!")
                    }
                })
        }
    }

    function GetCategoryID() {
        axios.get('https://serveremilia.mylksystems.com/Category/getcategoryID').then((res) => {
            setCategoryID(res.data.length + 1);
        })
    }

    function GetcategoryDetailsByCategoryID() {
        axios.get(`https://serveremilia.mylksystems.com/Category/getcategoryDetailsByID/${updateID}`).then((res) => {
            if (res.data.length > 0) {
                setcategoryData({
                    ...categoryData,
                    categoryName: res.data[0].CategoryName,
                    isActive: res.data[0].IsActive == 1 ? true : false
                })
                setCategoryID(res.data[0].CategoryID);
                setIsUpdate(true);
            }
        })
    }

    return (
        <Dialog
            aria-labelledby="customized-dialog-title"
            open={dialogOpen}
            fullWidth={true}         // Ensures the dialog uses the full width of the container
            maxWidth='md'
        >
            <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
                {isUpdate ? 'Update Supplier' : 'Add Category'}
            </DialogTitle>
            <IconButton
                aria-label="close"
                onClick={handleClose}
                sx={{
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: (theme) => theme.palette.grey[500],
                }}
            >
                <CloseIcon sx={{ color: 'black' }} />
            </IconButton>
            <DialogContent dividers>
                <Container maxWidth={false}>
                    <Formik
                        initialValues={{
                            categoryID: categoryData.categoryID,
                            categoryName: categoryData.categoryName,
                            isActive: categoryData.isActive
                        }}

                        validationSchema={
                            Yup.object().shape({
                                categoryName: Yup.string()
                                    .required('Category Name is required')
                                    .test('no-leading-space', 'Category Name cannot start with a space', value => value && value.trim().length > 0),
                            })
                        }
                        onSubmit={() => UploadCategory()}
                        enableReinitialize
                    >
                        {({
                            errors,
                            handleBlur,
                            handleSubmit,
                            touched
                        }) => (
                            <form onSubmit={handleSubmit}>
                                <Box mt={0}>
                                    <Grid container spacing={2}>
                                        {/* <Grid item md={4} xs={12}>
                                            <TextField
                                                fullWidth
                                                error={Boolean(touched.categoryID && errors.categoryID)}
                                                helperText={touched.categoryID && errors.categoryID}
                                                onBlur={handleBlur}
                                                label="Category ID *"
                                                name='categoryID'
                                                value={categoryID}
                                                id='categoryID'
                                                onChange={(e) => handleChange(e)}
                                                variant="outlined"
                                                size="small"
                                                type='text'
                                                inputProps={{
                                                    readOnly: 'true'
                                                }}
                                            />
                                        </Grid> */}
                                        <Grid item md={8} xs={12}>
                                            <TextField
                                                fullWidth
                                                error={Boolean(touched.categoryName && errors.categoryName)}
                                                helperText={touched.categoryName && errors.categoryName}
                                                onBlur={handleBlur}
                                                label="Category Name *"
                                                name='categoryName'
                                                value={categoryData.categoryName}
                                                id='categoryName'
                                                onChange={(e) => handleChange(e)}
                                                variant="outlined"
                                                size="small"
                                                type='text'
                                            />
                                        </Grid>
                                        <Grid item md={4} xs={12} sx={{ display: 'flex', justifyContent: 'start', alignItems: 'center' }}>
                                            <Typography>Active</Typography>
                                            &nbsp;
                                            <Switch
                                                checked={categoryData.isActive}
                                                onChange={handleStatusChange}
                                                status="isActive"
                                                label="Active"
                                            />
                                        </Grid>
                                        <Grid item md={12} xs={12} sx={{ display: 'flex', justifyContent: 'end' }}>
                                            {isUpdate ? null :
                                                <Button
                                                    variant="contained"
                                                    sx={{ width: '20%' }}
                                                    size='small'
                                                    onClick={ClearData}
                                                >
                                                    clear
                                                </Button>}
                                            &nbsp; &nbsp;
                                            <Button
                                                variant="contained"
                                                type='submit'
                                                sx={{ width: '20%' }}
                                                size='small'
                                            >
                                                {isUpdate ? 'Update' : 'Submit'}
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Box>
                            </form>
                        )}

                    </Formik>
                </Container>
            </DialogContent>
        </Dialog>
    )
}